import { render } from "./TheAdminClinicShow.vue?vue&type=template&id=080ec601&scoped=true&ts=true"
import script from "./TheAdminClinicShow.vue?vue&type=script&lang=ts"
export * from "./TheAdminClinicShow.vue?vue&type=script&lang=ts"

import "./TheAdminClinicShow.vue?vue&type=style&index=0&id=080ec601&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080ec601"]])

export default __exports__